// Full-document render of the anonymous order-lookup ("Find Your Order")
// page (/orders/): PageSkeleton wrapping the legacy sealy layout -- the
// centered status-container with the floating-label lookup form
// (email / order number / zip) and the orders_header intro line from
// CustomerServiceSettings. The menu-container column keeps the empty nav
// shell the legacy {% get_nav_menu 'side' %} emitted: sealy defines no
// 'side' NavMenu and its nav_menus/tags/menu.html override renders
// footer_column blocks only, so the column was an empty, unstyled nav.
import React from "react";
import { ReactivatedFormWidget } from "tsi-common-react/src/forms/ReactivatedFormWidget/index";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.OrderLookupDocumentTemplate,
): React.JSX.Element => {
    // Non-field errors land under __all__ (raised by clean() without a field).
    // Annotate as Record to allow __all__ key access.
    const formErrors: Record<string, readonly string[] | undefined> | null =
        props.form.errors;
    const nonFieldErrors = formErrors?.["__all__"] ?? null;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <section id="order-lookup" className="order-support">
                <div className="main-container">
                    <div className="menu-container">
                        <nav className="footer__nav" />
                    </div>
                    <div className="detail-container">
                        <section className="status-container">
                            <h1>Find Your Order</h1>
                            <p>{props.orders_header}</p>
                            <form method="post">
                                <CSRFToken />
                                {props.form.iterator.map((name) => {
                                    const field = props.form.fields[name];
                                    const errors = formErrors?.[name];
                                    return (
                                        <div key={name}>
                                            <div className="input-container">
                                                <ReactivatedFormWidget
                                                    widget={field.widget}
                                                />
                                                <label
                                                    htmlFor={
                                                        field.widget.attrs.id
                                                    }
                                                >
                                                    {field.label}
                                                </label>
                                                {errors &&
                                                    errors.length > 0 && (
                                                        <ul className="errorlist">
                                                            {errors.map(
                                                                (error, i) => (
                                                                    <li key={i}>
                                                                        {error}
                                                                    </li>
                                                                ),
                                                            )}
                                                        </ul>
                                                    )}
                                            </div>
                                        </div>
                                    );
                                })}
                                {nonFieldErrors &&
                                    nonFieldErrors.length > 0 && (
                                        <ul className="errorlist nonfield">
                                            {nonFieldErrors.map((error, i) => (
                                                <li key={i}>{error}</li>
                                            ))}
                                        </ul>
                                    )}
                                <input
                                    className="button button--primary"
                                    type="submit"
                                    value="Look Up"
                                />
                            </form>
                        </section>
                    </div>
                </div>
            </section>
        </PageSkeleton>
    );
};
